import { PRIZM_ENGLISH_LANGUAGE_COUNTRIES } from './countries';
import { PrizmLanguageCore } from '../../interfaces';

export const PRIZM_ENGLISH_LANGUAGE_CORE: PrizmLanguageCore = {
  months: [
    `January`,
    `February`,
    `March`,
    `April`,
    `May`,
    `June`,
    `July`,
    `August`,
    `September`,
    `October`,
    `November`,
    `December`,
  ],
  close: `Close`,
  nothingFoundMessage: `Nothing found`,
  defaultErrorMessage: `The field is filled incorrectly`,
  spinTexts: [`Previous`, `Next`],
  shortWeekDays: [`Mo`, `Tu`, `We`, `Th`, `Fr`, `Sa`, `Su`],
  countries: PRIZM_ENGLISH_LANGUAGE_COUNTRIES,
};
